import React from "react"
import styles from "./blockMarginTextImageRight.module.css"

const BlockMarginTextImageRight = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={`${styles.blockMarginTextImageRight} bg-cream-light`}>
      <div className={styles.blockMarginTextImageRight__text}>
        <h2>{title}</h2>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      <div className={styles.blockMarginTextImageRight__img}>
        <img src={`https://drupal.smartempo.com${image}`} alt={title} />
      </div>
    </section>
  )
}
export default BlockMarginTextImageRight
